import React from 'react';
import Icon from '../../../components/AppIcon';

const SavePreferences = ({ onSave, saving, success, disabled }) => {
  if (success) {
    return (
      <div style={{
        background: '#0A1220',
        border: '1px solid rgba(59,111,212,0.3)',
        padding: '40px',
        position: 'relative',
        overflow: 'hidden',
        marginBottom: '32px',
        textAlign: 'center'
      }}>
        {/* Polaroid-style success card */}
        <div style={{
          display: 'inline-block',
          background: '#EEF0F2',
          padding: '24px 24px 40px',
          transform: 'rotate(-1.5deg)',
          boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
          marginBottom: '28px',
          maxWidth: '280px'
        }}>
          <div style={{
            width: '100%',
            height: '120px',
            background: 'linear-gradient(135deg, #3B6FD4 0%, #E8630A 100%)',
            marginBottom: '16px',
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="square">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <div style={{
            fontFamily: 'Georgia, serif', fontStyle: 'italic',
            fontSize: '0.9375rem', color: '#050A12',
            textAlign: 'center', lineHeight: 1.5
          }}>Innstillinger lagret!</div>
        </div>

        <div style={{
          fontFamily: 'Impact, Arial Black, sans-serif',
          fontSize: 'clamp(24px, 3.5vw, 40px)',
          fontWeight: 900, color: '#EEF0F2',
          letterSpacing: '-0.02em', textTransform: 'uppercase',
          marginBottom: '12px'
        }}>LAGRET!</div>

        <p style={{
          fontFamily: 'Georgia, serif', fontStyle: 'italic',
          fontSize: '1rem', color: 'rgba(138,149,163,0.7)',
          lineHeight: 1.6, maxWidth: '400px', margin: '0 auto'
        }}>
          Dine nyhetsbrevinnstillinger er oppdatert. Endringene trer i kraft fra neste utsendelse.
        </p>
      </div>
    );
  }

  return (
    <div style={{
      background: '#0A1220',
      border: '1px solid rgba(255,255,255,0.06)',
      padding: '40px',
      position: 'relative',
      overflow: 'hidden',
      marginBottom: '32px'
    }}>
      {/* Color block accent */}
      <div style={{
        position: 'absolute', top: 0, left: 0,
        width: '4px', height: '100%',
        background: 'linear-gradient(to bottom, #3B6FD4, #E8630A)'
      }} />

      <div style={{ paddingLeft: '20px', position: 'relative', zIndex: 1 }}>
        <div style={{
          fontFamily: 'Syne, sans-serif',
          fontSize: '0.65rem', fontWeight: 700,
          color: '#3B6FD4', letterSpacing: '0.2em',
          textTransform: 'uppercase', marginBottom: '12px'
        }}>STEG 04 — LAGRE</div>

        <div style={{
          fontFamily: 'Impact, Arial Black, sans-serif',
          fontSize: 'clamp(22px, 3vw, 32px)',
          fontWeight: 900, color: '#EEF0F2',
          letterSpacing: '-0.02em', textTransform: 'uppercase',
          marginBottom: '8px'
        }}>LAGRE INNSTILLINGER</div>

        <p style={{
          fontFamily: 'Georgia, serif', fontStyle: 'italic',
          fontSize: '0.9375rem', color: 'rgba(138,149,163,0.7)',
          lineHeight: 1.6, marginBottom: '28px', maxWidth: '480px'
        }}>
          Klikk nedenfor for å lagre dine preferanser. Endringene vil gjelde fra neste nyhetsbrev.
        </p>

        <button
          onClick={onSave}
          disabled={saving || disabled}
          style={{
            padding: '16px 40px',
            background: saving || disabled ? 'rgba(59,111,212,0.4)' : '#3B6FD4',
            border: 'none',
            color: '#EEF0F2',
            fontFamily: 'Syne, sans-serif',
            fontSize: '0.9375rem',
            fontWeight: 800,
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            cursor: saving || disabled ? 'not-allowed' : 'pointer',
            display: 'flex', alignItems: 'center', gap: '10px',
            transition: 'background 200ms ease',
            position: 'relative',
            overflow: 'hidden'
          }}
          onMouseEnter={(e) => { if (!saving && !disabled) e.currentTarget.style.background = '#2D5AB8'; }}
          onMouseLeave={(e) => { if (!saving && !disabled) e.currentTarget.style.background = '#3B6FD4'; }}
        >
          {saving ? (
            <><Icon name="Loader" size={16} color="#EEF0F2" /> Lagrer...</>
          ) : (
            <><Icon name="Save" size={16} color="#EEF0F2" /> Lagre preferanser</>
          )}
        </button>
      </div>
    </div>
  );
};

export default SavePreferences;
